import Api from "@/api/Api";
import uploadWithAuth from "@/api/ApiUpload";
import errorHandler from "@/utils/plugins/ErrorHandler";

const RESOURCE_NAME = "/api/social_fund_call_periods";

export default {
  getCallPeriods(params) {
    return Api()
      .get(RESOURCE_NAME, { params })
      .catch((err) => errorHandler(err, null));
  },
  getCallPeriod(id) {
    return Api()
      .get(`${RESOURCE_NAME}/${id}`)
      .catch((err) => errorHandler(err, null));
  },
  createCallPeriod(data) {
    // Sin .catch: el componente necesita leer el 422 si las fechas se solapan
    // con una convocatoria ya abierta o el año ya existe.
    return Api().post(RESOURCE_NAME, data);
  },
  updateCallPeriod(id, data) {
    return Api().put(`${RESOURCE_NAME}/${id}`, data);
  },
  // F8 (fondo_social/v1-20260923/PLAN_FRONTEND.md): convenio en PDF por
  // convocatoria, con histórico de versiones.
  getAgreementHistory(callPeriodId) {
    return Api()
      .get(`${RESOURCE_NAME}/${callPeriodId}/agreement`)
      .catch((err) => errorHandler(err, null));
  },
  // Multipart, saltándose Api() (Content-Type ld+json) — uploadWithAuth()
  // reintenta una vez con el token refrescado si el JWT ha caducado. Sin
  // .catch: el 422 (tamaño) o 403 (Administración, si se diera el caso) los
  // maneja el componente.
  uploadAgreement(callPeriodId, file) {
    const formData = new FormData();
    formData.append("file", file);
    return uploadWithAuth({
      method: "post",
      url: `${process.env.VUE_APP_BASE_URI}${RESOURCE_NAME}/${callPeriodId}/agreement`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
      },
    });
  },
  downloadAgreement(callPeriodId, documentId) {
    return Api().get(`${RESOURCE_NAME}/${callPeriodId}/agreement/${documentId}/download`, { responseType: "blob" });
  },
  // 2026-09-29: si se borra el vigente, el backend recalcula automáticamente
  // el nuevo vigente (el más reciente de los que queden) — el frontend solo
  // tiene que recargar el histórico tras el 204.
  deleteAgreement(callPeriodId, documentId) {
    return Api().delete(`${RESOURCE_NAME}/${callPeriodId}/agreement/${documentId}`);
  },
};
